
const vScale = (scale, vec) => vec.map(n => n * scale);

const vAdd = (v0, v1) => [v0[0] + v1[0], v0[1] + v1[1]];

const vAngle = (a) => [Math.cos(a), Math.sin(a)];

export { vAdd, vScale, vAngle };
